export const STAFF_CODE = "Mã nhân viên"
export const DATE = "Ngày"
export const TIME = "Giờ chấm công"